<template>
  <footer class="app-footer not-for-print">
    <div class="app-footer__inner">
      <div class="app-footer__brand">
        <span class="app-footer__mark" aria-hidden="true"></span>
        <div class="app-footer__copy">
          <div class="app-footer__title">
            <a href="https://huestimates.com/" target="_blank" rel="noopener noreferrer">Progress IMS</a>
            <span class="app-footer__dot">Medical Online</span>
          </div>
          <p class="app-footer__meta">© {{ year }} · {{ $t("footerProduct") || "Klinika və aptek informasiya sistemi" }}</p>
        </div>
      </div>

      <div class="app-footer__aside">
        <span class="app-footer__version" :title="builtAt || undefined">
          <i class="fas fa-code-branch" aria-hidden="true"></i>
          {{ fullVersion }}
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  computed: {
    fullVersion() {
      return process.env.VUE_APP_FULL_VERSION || `v.${process.env.VUE_APP_VERSION || "2.4.5"}`;
    },
    builtAt() {
      return process.env.VUE_APP_BUILT_AT || "";
    },
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
